;(() => {
	// Duplica le slide in base alle slide visibili correnti e garantisce il loop.
	const setSlides = (sliders) => {
	  if (!sliders || sliders.length === 0) return;
  
	  sliders.forEach((swiperEl) => {
		const wrapper = swiperEl.querySelector('.swiper-wrapper');
		if (!wrapper) return;
  
// salvo solo una volta i blocchi originali e solo gli .logo-list__item
if (!wrapper._originalSlides) {
	wrapper._originalSlides = Array.from(wrapper.querySelectorAll('.logo-list__item')).map(slide => slide.cloneNode(true));
  } else {
	wrapper.innerHTML = '';
	wrapper._originalSlides.forEach(clone => wrapper.appendChild(clone.cloneNode(true)));
  }
  
		const isHorizontal = swiperEl.classList.contains('logo-list__content--horizontal-carousel');
  
		// slidesPerView effettive per viewport + layout
		let spv;
		if (window.matchMedia('(min-width: 1200px)').matches) {
		  spv = isHorizontal ? 4 : 3;
		} else if (window.matchMedia('(min-width: 990px)').matches) {
		  spv = isHorizontal ? 4 : 3;
		} else if (window.matchMedia('(min-width: 750px)').matches) {
		  spv = 3;
		} else {
		  spv = isHorizontal ? 2 : 3;
		}
  
		// Assicura che ogni item sia una vera swiper-slide
		const items = Array.from(wrapper.querySelectorAll('.logo-list__item'));
		items.forEach((it) => it.classList.add('swiper-slide'));
		// prendo solo le slide originali
		const baseSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

		// minimo per un true-marquee: almeno 4x spv
		const minRequired = spv * 4;

		let total = wrapper.querySelectorAll('.swiper-slide').length;

		// duplica finché non raggiungi la soglia
		while (total < minRequired) {
		baseSlides.forEach(s => wrapper.appendChild(s.cloneNode(true)));
		total = wrapper.querySelectorAll('.swiper-slide').length;
		}
	  });
	};
  
	const recalculateSlidesLength = (root) => {
	  const scope = root || document;
	  setSlides(scope.querySelectorAll('.js-slider-logos'));
	  setSlides(scope.querySelectorAll('.js-slider-logos-slow'));
	};
  
	const initSlider = (section) => {
	  let logosSlider;
	  let logosSliderSlow;
  
	  if (document.currentScript) {
		const parent = document.currentScript.parentElement;
		logosSlider = parent.querySelectorAll('.js-slider-logos');
		logosSliderSlow = parent.querySelectorAll('.js-slider-logos-slow');
	  } else {
		logosSlider = section.querySelectorAll('.js-slider-logos');
		logosSliderSlow = section.querySelectorAll('.js-slider-logos-slow');
	  }
  
	  if (logosSlider && logosSlider.length > 0) {
		logosSlider.forEach((el) => {
		  const speed1 = el.getAttribute('data-duration') || 4000;
		  const isMobile = window.matchMedia('(max-width: 750px)').matches;
		  const adjustedSpeed = isMobile ? Math.max(2000, Math.ceil(speed1 / 2)) : speed1;
  
		  // Distrugge un'eventuale istanza esistente prima di ricrearla
		  if (el.swiper) el.swiper.destroy(true, true);
  
		  new Swiper(el, {
			// Base (mobile)
			slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 2 : 3,
			spaceBetween: 16,
			direction: 'horizontal',
			speed: adjustedSpeed,
  
			// Loop continuo e stabile
			loop: true,
			loopedSlides: 50,
			loopAdditionalSlides: 8,
			loopPreventsSlide: false,
  
			// Autoplay senza pause
			autoplay: {
			  delay: 0,
			  disableOnInteraction: false,
			  pauseOnMouseEnter: false,
			},
  
			// Scorrimento "marquee": niente interazione utente
			allowTouchMove: false,
			shortSwipes: false,
			longSwipes: false,
  
			// Migliora continuità durante il wrap
			watchSlidesProgress: true,
  
			breakpoints: {
			  750: {
				direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
				slidesPerView: 3,
				spaceBetween: 20,
			  },
			  990: {
				direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
				slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 4 : 3,
				spaceBetween: 24,
			  },
			  1200: {
				direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
				slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 4 : 3,
				spaceBetween: 24,
			  },
			},
		  });
		});
	  }
  
	  if (logosSliderSlow && logosSliderSlow.length > 0) {
		logosSliderSlow.forEach((el) => {
		  const speed2 = el.getAttribute('data-duration') || 4000;
		  const isMobile = window.matchMedia('(max-width: 750px)').matches;
		  const adjustedSpeed = isMobile ? Math.max(2000, Math.ceil(speed2 / 2)) : speed2;
  
		  if (el.swiper) el.swiper.destroy(true, true);
  
		  new Swiper(el, {
			slidesPerView: 3,
			spaceBetween: 16,
			direction: 'horizontal',
			speed: adjustedSpeed,
  
			loop: true,
			loopedSlides: 50,
			loopAdditionalSlides: 8,
			loopPreventsSlide: false,
  
			autoplay: {
			  delay: 0,
			  disableOnInteraction: false,
			  pauseOnMouseEnter: false,
			},
  
			allowTouchMove: false,
			shortSwipes: false,
			longSwipes: false,
			watchSlidesProgress: true,
  
			breakpoints: {
			  750: {
				direction: 'vertical',
				slidesPerView: 3,
				spaceBetween: 20,
			  },
			  990: {
				direction: 'vertical',
				slidesPerView: 3,
				spaceBetween: 24,
			  },
			},
		  });
		});
	  }
	};
  
	const initSection = (section) => {
	  let sectionLogos;
	  if (document.currentScript) {
		sectionLogos = document.currentScript.parentElement;
	  } else {
		sectionLogos = section || document;
	  }
  
	  // Prima prepara le slide, poi inizializza Swiper
	  recalculateSlidesLength(sectionLogos);
	  initSlider(sectionLogos);
  
	  // Reinizializza su resize del contenitore (senza accumulare duplicati)
	  const sectionResizeObserver = new ResizeObserver((entries) => {
		const [entry] = entries;
		const scope = entry.target;
  
		const sliders = scope.querySelectorAll('.js-slider-logos');
		const slidersSlow = scope.querySelectorAll('.js-slider-logos-slow');
  
		sliders.forEach((s) => { if (s.swiper) s.swiper.destroy(true, true); });
		slidersSlow.forEach((s) => { if (s.swiper) s.swiper.destroy(true, true); });
  
		recalculateSlidesLength(scope);
		initSlider(scope);
	  });
  
	  sectionResizeObserver.observe(sectionLogos);
	};
  
	// Avvio iniziale
	initSection();
  
	// Re-init quando si ricarica una sezione dal Theme Editor di Shopify
	document.addEventListener('shopify:section:load', function (ev) {
	  initSection(ev.target);
	});
  })();